import { render, staticRenderFns } from "./thankYou.vue?vue&type=template&id=13598129&scoped=true&"
import script from "./thankYou.vue?vue&type=script&lang=js&"
export * from "./thankYou.vue?vue&type=script&lang=js&"
import style0 from "./thankYou.vue?vue&type=style&index=0&id=13598129&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13598129",
  null
  
)

export default component.exports